import { useEffect, useState } from "react";
import { api, apiError } from "../lib/api";
import { X } from "lucide-react";
import { toast } from "sonner";

export default function FormFillSheet({ form, onClose, onSaved }) {
  const [students, setStudents] = useState([]);
  const [studentId, setStudentId] = useState("");
  const [data, setData] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/students").then((r) => { setStudents(r.data); setStudentId(r.data[0]?.id || ""); });
  }, []);

  const submit = async () => {
    if (!studentId) { toast.error("Select a student"); return; }
    if (!form.fields.some((f) => (data[f] || "").trim())) { toast.error("Fill in at least one field"); return; }
    setSaving(true);
    try {
      await api.post("/form-submissions", { form_key: form.key, student_id: studentId, date: new Date().toISOString().slice(0, 10), data });
      toast.success(`${form.name} submitted`);
      onSaved();
    } catch (e) { toast.error(apiError(e)); }
    setSaving(false);
  };

  return (
    <div className="fixed inset-0 z-50 bg-slate-900/50 sf-overlay flex items-end sm:items-center justify-center" onClick={onClose}>
      <div data-testid="form-fill-sheet" className="sf-sheet bg-white w-full sm:max-w-lg sm:rounded-2xl rounded-t-2xl max-h-[92vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="sticky top-0 bg-white border-b border-slate-100 px-5 py-4 flex items-center justify-between z-10">
          <div>
            <h2 className="font-heading font-semibold text-slate-900">{form.name}</h2>
            <p className="text-xs text-slate-400">{form.description}</p>
          </div>
          <button data-testid="close-form-fill-btn" onClick={onClose} className="p-2 text-slate-400 hover:text-slate-700"><X size={18} /></button>
        </div>
        <div className="p-5 space-y-4">
          <div>
            <label className="text-xs font-bold tracking-[0.06em] uppercase text-slate-500">Student</label>
            <select data-testid="form-student-select" value={studentId} onChange={(e) => setStudentId(e.target.value)}
              className="mt-1 w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-600">
              {students.map((s) => <option key={s.id} value={s.id}>{s.first_name} {s.last_name}</option>)}
            </select>
          </div>
          {form.fields.map((f, i) => (
            <div key={f}>
              <label className="text-xs font-bold tracking-[0.06em] uppercase text-slate-500">{f}</label>
              <textarea data-testid={`form-field-${i}`} rows={2} value={data[f] || ""} onChange={(e) => setData((d) => ({ ...d, [f]: e.target.value }))}
                className="mt-1 w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-600" />
            </div>
          ))}
          <button data-testid="submit-form-fill-btn" onClick={submit} disabled={saving}
            className="w-full bg-emerald-700 hover:bg-emerald-800 text-white font-semibold rounded-full py-3 text-sm transition-colors duration-150 active:scale-[0.98] disabled:opacity-60">
            {saving ? "Submitting…" : "Submit form"}
          </button>
        </div>
      </div>
    </div>
  );
}
